import {Project} from "../domain/entities/project.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class UpdateProjectCommand extends AbstractCommand<Project> {

    public name: CommandName = CommandName.UPDATE_PROJECT;

    public tags = ['entity', 'change', 'project'];

    constructor(payload: Project) {
        super('project', payload.uid, payload);
    }
}